'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var slicedToArray = require('../../../../external/@babel/runtime/helpers/esm/slicedToArray.js');

var React = require('react');

var index = require('../../../../external/classnames/index.js');

var PropTypes = require('prop-types');

var NavDropdownSidebar = require('./NavDropdownSidebar/NavDropdownSidebar.js');

require('./NavDropdownSidebar/NavDropdownSidebarLG.js');

var NavDropdownIndexContent = require('./NavDropdownIndexContent/NavDropdownIndexContent.js');

var useOutsideClick = require('../../../../utilities/hooks/useOutsideClick.js');

var times_inline = require('../../../../assets/svg/times.inline.svg.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var MENU_ARTICLE_ITEM_MAP = {
  'SCIENCE & INNOVATION': 'menu_articles_science',
  COLLABORATION: 'menu_articles_collaboration',
  COMMUNITY: 'menu_articles_community',
  ENVIRONMENT: 'menu_articles_environment'
};

var NavDropdown = function NavDropdown(props) {
  var className = props.className,
      activeNavItem = props.activeNavItem,
      navItems = props.navItems,
      setActiveNavItem = props.setActiveNavItem,
      menuArticles = props.menuArticles;
  var ref = React.useRef();

  var _useState = React.useState(null),
      _useState2 = slicedToArray['default'](_useState, 2),
      activeGroup = _useState2[0],
      setActiveGroup = _useState2[1];

  var NavDropdownClasses = index['default'](className, 'lanl-nav-dropdown');
  var activeMenuGroup = navItems.find(function (item) {
    return item.name === activeNavItem;
  });
  var lc_page_groups = activeMenuGroup.lc_page_groups;
  var group = lc_page_groups.find(function (_ref) {
    var name = _ref.name;
    return name === activeGroup;
  });
  var activeMenuArticle = MENU_ARTICLE_ITEM_MAP[activeNavItem];
  var menuArticle = menuArticles[activeMenuArticle];
  useOutsideClick.useOutsideClick(ref, function () {
    setActiveNavItem(null);
  });
  React.useEffect(function () {
    setActiveGroup(null);
  }, [activeNavItem]);

  var renderNavItems = function renderNavItems() {
    var lc_pages = group.lc_pages;
    return lc_pages.map(function (_ref2) {
      var name = _ref2.name,
          link = _ref2.link;
      return /*#__PURE__*/React__default['default'].createElement("li", {
        key: "dropdown-item-".concat(name)
      }, /*#__PURE__*/React__default['default'].createElement("a", {
        href: link
      }, name));
    });
  };

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: NavDropdownClasses,
    "data-testid": "lanl-nav-dropdown"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    ref: ref,
    className: "content-container"
  }, /*#__PURE__*/React__default['default'].createElement(NavDropdownSidebar.NavDropdownSidebar, {
    activeMenuGroup: activeMenuGroup,
    activeGroup: activeGroup,
    setActiveGroup: setActiveGroup
  }), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "dropdown-main-area"
  }, activeGroup && group && /*#__PURE__*/React__default['default'].createElement("ul", null, /*#__PURE__*/React__default['default'].createElement("li", null, group.name), /*#__PURE__*/React__default['default'].createElement("li", null, /*#__PURE__*/React__default['default'].createElement("a", {
    href: group.link
  }, "View ", group.name)), renderNavItems()), !activeGroup && /*#__PURE__*/React__default['default'].createElement(NavDropdownIndexContent.NavDropdownIndexContent, {
    activeMenuArticle: activeMenuArticle,
    menuArticle: menuArticle
  }), /*#__PURE__*/React__default['default'].createElement(times_inline['default'], {
    className: "dropdown-close",
    onClick: function onClick() {
      return setActiveNavItem(null);
    }
  }))));
};

NavDropdown.defaultProps = {
  menuArticles: {},
  navItems: []
};
NavDropdown.propTypes = {
  activeNavItem: PropTypes__default['default'].string,
  children: PropTypes__default['default'].node,
  className: PropTypes__default['default'].string,
  menuArticles: PropTypes__default['default'].object,
  navItems: PropTypes__default['default'].array,
  setActiveNavItem: PropTypes__default['default'].func
};
exports.NavDropdown = NavDropdown;
exports['default'] = NavDropdown;